const BYTE_UNITS = ['KB', 'MB', 'GB', 'TB']

// Human-readable byte size ("120.0 MB"), shared by every devcontainer/host
// metrics display in the admin surfaces. `null` (metric unavailable, e.g. a
// stopped container or an unreadable /host_proc file) renders as an em dash.
export function formatBytes(bytes: number | null): string {
  if (bytes == null) return '—'
  if (bytes < 1024) return `${bytes} B`
  let value = bytes / 1024
  let unitIndex = 0
  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024
    unitIndex += 1
  }
  return `${value.toFixed(1)} ${BYTE_UNITS[unitIndex]}`
}
